export function hasLongText(pages) {
  return pages.some((page) => page.text?.length > 350);
}

export function getLongestText(pages) {
  return pages.reduce((longestText, page) => {
    const textLength = page.text?.length || 0;
    return textLength > longestText ? textLength : longestText;
  }, 0);
}
